import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import GtagService from 'modules/app/services/ga/GtagService';
import ConfigService from 'modules/configManager/ConfigService';

import { STATUS_PRODUCT_APPROVED } from './constants';
import Request from './OnboardingAPI';
import OnboardingStore from './OnboardingStore';

import { AuthService } from '../../../modules/auth';
import { ROLES } from '../../../modules/user/constants';

class OnboardingService {
  static async fetchProgress() {
    try {
      const customizationData = await ConfigService.fetchCustomizationData();

      return customizationData?.membershipId
        ? await Request('onboarding.checkProgress', {
            membershipId: customizationData?.membershipId
          })
        : {};
    } catch (error) {
      throw new Error(error);
    }
  }

  static async updateStatusContentAndApprovedStatus() {
    if (AuthService.is([ROLES.OWNER, ROLES.ADMIN])) {
      try {
        const response = await this.fetchProgress();

        OnboardingStore.setCheckList({
          hasModule: response?.hasModule,
          hasContent: response?.hasPage,
          publishedContent: response?.hasPagePublished
        });

        OnboardingStore.setProductIsApproved(
          response?.status === STATUS_PRODUCT_APPROVED
        );
      } catch (error) {
        throw new Error(error);
      }
    }
  }

  static async isEligible() {
    const isProductApproved = OnboardingStore.isProductApproved;
    const { hasModule, hasContent, publishedContent } =
      OnboardingStore.checkList;

    const rolesAccept = AuthService.is([ROLES.OWNER, ROLES.ADMIN]);
    const hasSomeOneIncomplete = !hasModule || !hasContent || !publishedContent;

    return rolesAccept && hasSomeOneIncomplete && !isProductApproved;
  }

  static async setOnboardingVisibility(status) {
    try {
      OnboardingStore.setShowVersionWithOnboarding(status);
    } catch (error) {
      throw new Error(error);
    }
  }

  static async initAbTestOnboarding() {
    const isUserEligible = await OnboardingService.isEligible();

    if (isUserEligible) {
      this.setOnboardingVisibility(true);
    }
  }

  static convertionEvent() {
    GtagService.sendEvent({
      event: 'noninteraction',
      category: 'Club:Admin:Content',
      action: 'Show',
      where: 'Onboarding',
      label: 'MembersAreaReady'
    });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.CONTENT_ONBOARDING,
        action: EVENTS_INTERACTIONS.SHOW,
        label: EVENTS_LABELS.CONTENT.CONTENT_ONBOARDING.MEMBERS_AREA_READY
      })
    });
  }

  static async init() {
    await this.updateStatusContentAndApprovedStatus();
    await this.initAbTestOnboarding();
  }
}

export default OnboardingService;
